import toast from 'react-hot-toast';

export const toastV2 = (message) => {
    toast.dismiss(); // this will dismiss any previous toast
    toast(message, {
        style: {
            borderRadius: '10px',
            background: '#000',
            color: '#fff',
            width: '100%',
            maxWidth: '400px',
            fontFamily: 'Inter',
        },
        duration: 1500
    });

    // on touch devices, if we touch the toast it doesn't close afterwards. This is the fix for that.
    setTimeout(() => {
        toast.dismiss();
    }, 2000);
};
